

// ********* Import CSS ***************** //

import "./youth-training.css";

// ********* Import Images ***************** //

//*** ASATTC Spinner Image ***//
import "../assets/asattc-round-favicon/asattc-round-favicon.png";

// ** LOGO ** //
import "../assets/logos/asattc-top-logo-white.svg";


// ** IMAGES ** //
import "../assets/asattc-images/asattc-students-learning.jpg";

import "../assets/asattc-student-images/asattc-chef-and-student-aprons.jpg";
import "../assets/asattc-student-images/asattc-chef-and-student-aprons-tall.png";
import "../assets/asattc-student-images/asattc-chef-jack-and-chef-teaching-students.png";
import "../assets/asattc-student-images/asattc-chef-jack-teaching-students.png";
import "../assets/asattc-student-images/asattc-chef-pointing-at-student.jpg";
import "../assets/asattc-student-images/asattc-chef-teaching-students.png";
import "../assets/asattc-student-images/asattc-finished-mural.jpg";


import "../assets/asattc-student-images/asattc-smiling-girl.jpg";
import "../assets/asattc-student-images/asattc-student.jpg";
import "../assets/asattc-student-images/IMG_0870.jpeg";
import "../assets/asattc-student-images/asattc-classroom.jpg";

import "../assets/asattc-student-images/chef-jack-ai-action-figure-1.jpg";

import "../assets/asattc-student-images/CWK4.jpg";

import "../assets/asattc-student-images/asattc-3-students-arms-around.png";
import "../assets/asattc-student-images/asattc-female-student-smiling.jpg";


import "../assets/asattc-student-images/asattc-students-grilling.jpeg";
import "../assets/asattc-student-images/asattc-students-writing-desk.jpeg";

import "../assets/asattc-student-images/asattc-chef-jack-classroom.jpeg";

// ** ICONS ** //
import "../assets/general-icons/cooking.png";
import "../assets/general-icons/customer-service.png";
import "../assets/general-icons/food-safety.png";
import "../assets/general-icons/male-professional.png";
import "../assets/general-icons/mentorship.png";
import "../assets/general-icons/personal-goals.png";
import "../assets/general-icons/teamwork.png";
import "../assets/general-icons/dollar-bills.png";
import "../assets/general-icons/paycheck.png";
import "../assets/general-icons/clock.png";
import "../assets/general-icons/chef-icon.png";
import "../assets/general-icons/fork-knife.svg";


// ********* Add Top Nav & Footer *************** //

import '../nav-header-footer/nav-header-footer.js';
import '../nav-header-footer/nav-header-footer.css';

// **************************** Spinner ****************************** //

$(window).on('load', function(){
  document.getElementById("spinner").style.display = "block";
  setTimeout(removeSpinner, 1000);
});

function removeSpinner(){
  $( "#spinner" ).fadeOut(100, function() {
    $( "#spinner" ).remove();
  });
}


function heroMediaQueries() {

  const mobileQuery = window.matchMedia('(max-width: 430px)');

  if (mobileQuery.matches) {

    console.log("mobileQuery"); 

    document.getElementById("icon-text-10").innerText="Performance-Based Pay";
  }
}


heroMediaQueries()